import { lazy, Suspense } from "react";
import { RouteObject } from "react-router";
import SuspenseLoader from "src/components/SuspenseLoader";
import Callback from "src/content/pages/Callback";

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const Status404 = Loader(
  lazy(() => import("src/content/pages/Status/Status404"))
);
const NewHomePage = Loader(
  lazy(() => import("src/components/LandingPage/Layout/index"))
);
const RegisterFormStepOne = Loader(
  lazy(
    () =>
      import(
        "src/content/pages/Auth/Signup/TemasekCorporate/Form/RegisterFormStepOne"
      )
  )
);
const RegisterFormStepTwo = Loader(
  lazy(
    () =>
      import(
        "src/content/pages/Auth/Signup/TemasekCorporate/Form/RegisterFormStepTwo"
      )
  )
);
const Invite = Loader(
  lazy(() => import("src/content/pages/Auth/Signup/TemasekVendor/Form/Invite"))
);
const OrgDetails = Loader(
  lazy(
    () => import("src/content/pages/Auth/Signup/TemasekVendor/Form/OrgDetails")
  )
);
const OrgTerms = Loader(
  lazy(
    () => import("src/content/pages/Auth/Signup/TemasekVendor/Form/OrgTerms")
  )
);

const ComimgSoon = Loader(
  lazy(() => import("src/components/_shared/ComingSoon"))
);

const PrivacyPolicy = Loader(
  lazy(() => import("src/components/LandingPage/Components/PrivacyPolicy"))
);

const UnAuthorized = Loader(
  lazy(() => import("src/content/pages/Status/Status401"))
);

const TermsAndUse = Loader(lazy(()=> import("src/components/LandingPage/Components/TermsAndUse")))

const publicRoutes: RouteObject[] = [
  {
    path: "",
    element: <NewHomePage />,
  },
  {
    path: "/home",
    element: <NewHomePage />,
  },
  {
    path: "privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "terms-of-use",
    element: <TermsAndUse />,
  },
  {
    path: "unauthorized",
    element: <UnAuthorized />,
  },
  {
    path: "sign-up/invite",
    element: <Invite />,
  },
  {
    path: `sign-up/company-details`,
    element: <OrgDetails />,
  },
  {
    path: "sign-up/terms",
    element: <OrgTerms />,
  },
  {
    path: "sign-up/corporate/step1",
    element: <RegisterFormStepOne />,
  },
  {
    path: "sign-up/corporate/step2",
    element: <RegisterFormStepTwo />,
  },
  {
    path: "*",
    element: <Status404 />,
  },
  {
    path: "comingsoon",
    element: <ComimgSoon />,
  },
  {
    path: "callback",
    element: <Callback />,
  },
];

export default publicRoutes;
